module.exports = __webpack_public_path__ + "img/image4.fd97ed66.jpg";